import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { TEAM_DESIGN_REDIRECT_LINK } from 'constants/links';

interface SetLanguageModalProps {
  isOpen: boolean;
}

/**
 * Modal to alert user that the design is being edited by a member of their team
 * When modal is closed or the user clicks the button, they are redirected to the shared with me page
 *
 * @param {boolean} isOpen - Whether the modal is open
 * @returns ReactElement
 */
const CollaborationAlert = ({ isOpen }: SetLanguageModalProps) => {
  const handleRedirect = () => {
    window.location.href = TEAM_DESIGN_REDIRECT_LINK;
  };

  const modalBodyTestId = 'collaboration-warning-modal-body';

  return (
    <Modal isOpen={isOpen} size={'sm'} onClose={handleRedirect} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>This design is being edited by a member of your team</ModalHeader>
        <ModalBody data-testid={modalBodyTestId}>
          <Text fontSize={'sm'}>You may continue editing when they leave the design.</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant={'action'} ml={3} size={'sm'} onClick={handleRedirect}>
            {'Go to My Designs'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export { CollaborationAlert };
